module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v(_vm._s(_vm.decimalPointToComma))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28ea808c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/decimalPointToComma.vue
// module id = 66
// module chunks = 0